export const sortBySortOrder = (arr) => {
    if (!Array.isArray(arr)) return arr;
    return arr
        .slice() // 不改变原数组
        .sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder))
        .map(item => ({
            ...item,
            // 递归对子数组排序
            children: item.children ? sortBySortOrder(item.children) : item.children,
        }));
}